import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { sepolia } from 'wagmi/chains'

export const config = getDefaultConfig({
  appName: 'Nullayer',
  projectId: '69691d76ab463045b11912102fdc5d58',
  chains: [sepolia],
  ssr: false,
})
